var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 90.7646C56.1737 90.6705 63.4054 87.6691 68.7341 82.4082C74.0628 77.1473 77.0611 70.049 77.0818 62.6453C77.1025 55.2417 74.144 48.1267 68.8448 42.8361C63.5456 37.5455 56.3308 34.5037 48.7578 34.3672L48.6 90.7646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0553 3.89002C37.4816 3.9841 30.2499 6.98552 24.9212 12.2464C19.5925 17.5073 16.5942 24.6056 16.5734 32.0092C16.5527 39.4128 19.5113 46.5279 24.8105 51.8185C30.1097 57.1091 37.3244 60.1509 44.8975 60.2874L45.0553 3.89002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1113 59.8223C14.1111 59.8952 14.1109 59.9681 14.1107 60.0502C14.0918 68.0772 17.2971 75.7911 23.0371 81.5323C28.777 87.2736 36.5929 90.5834 44.8031 90.7497L44.8894 59.9084L14.1113 59.8223Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8438 3.89648L48.7678 31.0433L79.35 31.1289C78.5063 23.7466 74.9475 16.915 69.3357 11.9054C63.7239 6.8959 56.4415 4.04969 48.8438 3.89648Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeIcon);
export default __webpack_public_path__ + "static/media/stake-icon.8d7a53f97ed5a15895cb3486613efa25.svg";
export { ForwardRef as ReactComponent };